<template>
  <div class="request-subjects__user text-dark">
    <div class="request-subjects__user__header">
      <h2 class="pad-1">{{ user.name }}</h2>
    </div>
    <div class="request-subjects__subsection">
      <table class="d-table">
        <thead>
        <tr>
          <th colspan="3"><h4>Dine ønsker – Undervisning</h4></th>
          <th class="number">{{ displaySumTeaching }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="userSubjectsTeaching.length === 0">
          <td colspan="4" class="italic">Ingen undervisning ønsket</td>
        </tr>
        <tr v-for="subject in userSubjectsTeaching" :key="subject.id">
          <td class="td-delete">
            <div class="icon__bg-circle icon-bin"
                 @click="$emit('removeSubject', subject.id)"
                 v-if="!loadingSubjects[subject.id]"
                 content="Fjern ønske"
                 v-tippy="{ arrow: true }"></div>
            <div class="do-spinner do-spinner-small" v-else></div>
          </td>
          <td class="td-subjects">
            <div class="subjects_subject subjects_subject__simple"
                 :class="{'subjects_subject--has-user': subject.vRequestedBy.length > 0}"
                 :style="[{'border-left-color': subject.color}, {'background-color': subject.color}]"
                 :content="!subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'"
                 v-tippy="{
            arrow: true,
            onShow: () => subject.vRequestedBy.length > 0
          }">
              {{ subject.name }}
            </div>
          </td>
          <td class="td-calendars">{{ subject.vKlass }}</td>
          <td class="number">
            {{ showLessonsPerWeek ? subject.vLessonsPerWeek : subject.vHours }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="userSubjectsOther.length > 0 && showOtherTasks" class="request-subjects__subsection">
      <table class="d-table">
        <thead>
        <tr>
          <th colspan="3"><h4>Dine ønsker – Øvrige opgaver</h4></th>
          <th class="number text--grey">{{ sumOfHoursOther }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="subject in userSubjectsOther" :key="subject.id">
          <td class="td-delete">
            <div class="icon__bg-circle icon-bin"
                 @click="$emit('removeSubject', subject.id)"
                 v-if="!loadingSubjects[subject.id]"
                 content="Fjern ønske"
                 v-tippy="{ arrow: true }"></div>
            <div class="do-spinner do-spinner-small" v-else></div>
          </td>
          <td class="td-subjects">
            <div class="subjects_subject subjects_subject__simple"
                 :class="{'subjects_subject--has-user': subject.vRequestedBy.length > 0}"
                 :style="[{'border-left-color': subject.color}, {'background-color': subject.color}]"
                 :content="!subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'"
                 v-tippy="{
            arrow: true,
            onShow: () => subject.vRequestedBy.length > 0
          }">
              {{ subject.name }}
            </div>
          </td>
          <td class="td-calendars">{{ subject.vKlass }}</td>
          <td class="number">
            {{ subject.vHours }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="showAssignedSubjects" class="request-subjects__user__section">
      <table class="d-table request-subjects__assigned">
        <thead style="padding:0">
        <tr @click="isAssignedTeachingOpen = !isAssignedTeachingOpen">
          <th colspan="2">
            <div class="request-subjects__toggle">
              <span class="request-subjects__toggle__left">
                <h4>Tildelt undervisning</h4>
                <span :class="isAssignedTeachingOpen ? 'icon-arrow-up4' : 'icon-arrow-down4'"></span>
              </span>
            </div>
          </th>
          <th class="number text--grey">{{ displayAssignedSumTeaching }}</th>
        </tr>
        </thead>
        <tbody v-if="isAssignedTeachingOpen">
        <tr v-if="assignedTeaching.length === 0">
          <td colspan="3" class="italic">Ingen fag eller undervisningsopgaver tildelt</td>
        </tr>
        <tr v-for="subject in assignedTeaching" :key="subject.rowId || subject.id">
          <td class="td-subjects td-subjects--assigned">
            <div class="subjects_subject subjects_subject__simple"
                 :style="[{'border-left-color': subject.color}, {'background-color': subject.color}]">
              {{ subject.name }}
            </div>
          </td>
          <td class="td-calendars">
            <div>{{ subject.vKlass }}</div>
          </td>
          <td class="number">
            {{ displayHours(subject.vHours) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="showAssignedSubjects && showOtherTasks && !showPoolInfo" class="request-subjects__user__section">
      <table class="d-table request-subjects__assigned">
        <thead style="padding:0">
        <tr @click="isAssignedOtherOpen = !isAssignedOtherOpen">
          <th colspan="2">
            <div class="request-subjects__toggle">
              <span class="request-subjects__toggle__left">
                <h4>Tildelt øvrige opgaver</h4>
                <span :class="isAssignedOtherOpen ? 'icon-arrow-up4' : 'icon-arrow-down4'"></span>
              </span>
            </div>
          </th>
          <th class="number text--grey">{{ assignedSumOther }}</th>
        </tr>
        </thead>
        <tbody v-if="isAssignedOtherOpen">
        <tr v-if="assignedOther.length === 0">
          <td colspan="3" class="italic">Ingen øvrige opgaver tildelt</td>
        </tr>
        <tr v-for="subject in assignedOther" :key="subject.rowId || subject.id">
          <td class="td-subjects td-subjects--assigned">
            <div class="subjects_subject subjects_subject__simple"
                 :style="[{'border-left-color': subject.color}, {'background-color': subject.color}]">
              {{ subject.name }}
            </div>
          </td>
          <td class="td-calendars">
            <div>{{ subject.vKlass }}</div>
          </td>
          <td class="number">
            {{ formatHours(subject.vHours) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <table v-if="showAssignedSubjects" class="d-table request-subjects__total">
      <thead>
      <tr>
        <th :colspan="!showPoolInfo ? 3 : 2"><h4>Samlet</h4></th>
        <td class="number text--grey" v-if="showPoolInfo">{{ displayTotalTeachingCombined }}</td>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td colspan="2">Ønsket undervisning</td>
        <td class="number text-dark">{{ displaySumTeaching }}</td>
      </tr>
      <tr>
        <td colspan="2">Tildelt undervisning</td>
        <td class="number text-dark">{{ displayAssignedSumTeaching }}</td>
      </tr>
      <template v-if="showOtherPoolInfo">
      <tr>
        <td colspan="2">Ønsket øvrige opgaver</td>
        <td class="number text-dark">{{ sumOfHoursOther }}</td>
      </tr>
      <tr>
        <td colspan="2">Tildelt øvrige opgaver</td>
        <td class="number text-dark">{{ assignedSumOther }}</td>
      </tr>
      </template>
      <template v-if="showPoolInfo">
      <tr class="pool-summary">
        <td>
          <span class="pool-label">UV-pulje</span>
          <span class="pool-value">{{ displayPoolTeachingHours }}</span>
        </td>
        <td>
          <span class="pool-label">Ønsket og tildelt</span>
          <span class="pool-value">{{ displayTotalTeachingCombined }}</span>
        </td>
        <td>
          <span class="pool-label">Rest</span>
          <span class="pool-value" :class="{'pool-value--negative': parseFloat(teachingDiff) < 0}">{{ displayTeachingDiff }}</span>
        </td>
      </tr>
      </template>
      <template v-if="!showPoolInfo">
      <tr v-if="showOtherTasks">
        <td colspan="2">Ønsket øvrige opgaver</td>
        <td class="number text-dark">{{ sumOfHoursOther }}</td>
      </tr>
      <tr v-if="showOtherTasks">
        <td colspan="2">Tildelt øvrige opgaver</td>
        <td class="number text-dark">{{ assignedSumOther }}</td>
      </tr>
      <tr>
        <td colspan="2"><strong>I alt</strong></td>
        <td class="number text-dark"><strong>{{ totalSumOfHours }}</strong></td>
      </tr>
      </template>
      </tbody>
    </table>
    <div v-if="showAssignedSubjects && showOtherTasks && showPoolInfo" class="request-subjects__user__section">
      <table class="d-table request-subjects__assigned marg-1-top">
        <thead style="padding:0">
        <tr @click="isAssignedOtherOpen = !isAssignedOtherOpen">
          <th colspan="2">
            <div class="request-subjects__toggle">
              <span class="request-subjects__toggle__left">
                <h4>Tildelt øvrige opgaver</h4>
                <span :class="isAssignedOtherOpen ? 'icon-arrow-up4' : 'icon-arrow-down4'"></span>
              </span>
            </div>
          </th>
          <th class="number text-dark">{{ assignedSumOther }}</th>
        </tr>
        </thead>
        <tbody v-if="isAssignedOtherOpen">
        <tr v-if="assignedOther.length === 0">
          <td colspan="3" class="italic">Ingen øvrige opgaver tildelt</td>
        </tr>
        <tr v-for="subject in assignedOther" :key="subject.rowId || subject.id">
          <td class="td-subjects td-subjects--assigned">
            <div class="subjects_subject subjects_subject__simple"
                 :style="[{'border-left-color': subject.color}, {'background-color': subject.color}]">
              {{ subject.name }}
            </div>
          </td>
          <td class="td-calendars">
            <div>{{ subject.vKlass }}</div>
          </td>
          <td class="number">
            {{ formatHours(subject.vHours) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <table v-if="showOtherPoolInfo" class="d-table request-subjects__total">
      <tbody>
      <tr class="pool-summary">
        <td>
          <span class="pool-label">Øvrig-pulje</span>
          <span class="pool-value">{{ poolOtherHours }}</span>
        </td>
        <td>
          <span class="pool-label">Ønsket og tildelt</span>
          <span class="pool-value">{{ totalOtherCombined }}</span>
        </td>
        <td>
          <span class="pool-label">Rest</span>
          <span class="pool-value" :class="{'pool-value--negative': parseFloat(otherDiff) < 0}">{{ otherDiff }}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isAssignedTeachingOpen: false,
      isAssignedOtherOpen: false
    }
  },
  props: {
    user: {
      type: Object,
      default: {
        name: ''
      }
    },
    assignedTeaching: {
      type: Array,
      default: () => []
    },
    assignedOther: {
      type: Array,
      default: () => []
    },
    showAssignedSubjects: {
      type: Boolean,
      default: true
    },
    userSubjectsTeaching: {
      type: Array,
      default: () => []
    },
    userSubjectsOther: {
      type: Array,
      default: () => []
    },
    allCalendarsInHash: {
      type: Object,
      default: () => {
      }
    },
    loadingSubjects: {
      default: {}
    },
    isPoolsDeactivated: {
      type: Boolean,
      default: true
    },
    poolTeachingHours: {
      type: Number,
      default: 0
    },
    poolOtherHours: {
      type: Number,
      default: 0
    },
    hasOtherSubjects: {
      type: Boolean,
      default: false
    },
    showLessonsPerWeek: {
      type: Boolean,
      default: false
    },
    subjectDefaultDuration: {
      type: Number,
      default: 45
    }
  },
  computed: {
    assignedSumTeaching () {
      return this.sumHoursForRows(this.assignedTeaching)
    },
    assignedSumOther () {
      return this.sumHoursForRows(this.assignedOther)
    },
    assignedSumTotal () {
      return (parseFloat(this.assignedSumTeaching) + parseFloat(this.assignedSumOther)).toFixed(1)
    },
    sumOfHoursTeaching () {
      return this.sumHoursForSubjects(this.userSubjectsTeaching)
    },
    sumOfHoursOther () {
      return this.sumHoursForSubjects(this.userSubjectsOther)
    },
    totalTeachingCombined () {
      return (parseFloat(this.sumOfHoursTeaching) + parseFloat(this.assignedSumTeaching)).toFixed(1)
    },
    totalOtherCombined () {
      return (parseFloat(this.sumOfHoursOther) + parseFloat(this.assignedSumOther)).toFixed(1)
    },
    totalSumOfHours () {
      return (parseFloat(this.totalTeachingCombined) + parseFloat(this.totalOtherCombined)).toFixed(1)
    },
    showOtherTasks () {
      return this.hasOtherSubjects && this.assignedOther.length > 0
    },
    showPoolInfo () {
      return !this.isPoolsDeactivated && this.showAssignedSubjects
    },
    teachingDiff () {
      return (this.poolTeachingHours - parseFloat(this.totalTeachingCombined)).toFixed(1)
    },
    showOtherPoolInfo () {
      return this.showPoolInfo && this.hasOtherSubjects
    },
    otherDiff () {
      return (this.poolOtherHours - parseFloat(this.totalOtherCombined)).toFixed(1)
    },
    displaySumTeaching () {
      if (this.showLessonsPerWeek) {
        return this.userSubjectsTeaching
          .reduce(function (sum, s) { return sum + parseFloat(s.vLessonsPerWeek || 0) }, 0)
          .toFixed(1)
      }
      return this.sumOfHoursTeaching
    },
    displayAssignedSumTeaching () {
      return this.showLessonsPerWeek ? this.calcLessonsPerWeek(parseFloat(this.assignedSumTeaching)) : this.assignedSumTeaching
    },
    displayTotalTeachingCombined () {
      if (this.showLessonsPerWeek) {
        return (parseFloat(this.displaySumTeaching) + parseFloat(this.displayAssignedSumTeaching)).toFixed(1)
      }
      return this.totalTeachingCombined
    },
    displayPoolTeachingHours () {
      return this.showLessonsPerWeek ? this.calcLessonsPerWeek(this.poolTeachingHours) : this.poolTeachingHours
    },
    displayTeachingDiff () {
      if (this.showLessonsPerWeek) {
        return (parseFloat(this.displayPoolTeachingHours) - parseFloat(this.displayTotalTeachingCombined)).toFixed(1)
      }
      return this.teachingDiff
    }
  },
  methods: {
    calcLessonsPerWeek (hours) {
      return this.$helpers.calcLessonsPerWeek(hours, this.subjectDefaultDuration)
    },
    displayHours (hours) {
      if (this.showLessonsPerWeek) {
        return this.calcLessonsPerWeek(this.getNumericHours(hours))
      }
      return this.formatHours(hours)
    },
    sumHoursForSubjects (subjects) {
      return subjects
        .reduce((sum, subject) => sum + this.getNumericHours(subject.vHours), 0)
        .toFixed(1)
    },
    sumHoursForRows (rows) {
      return rows
        .reduce((sum, subject) => sum + this.getNumericHours(subject.vHours), 0)
        .toFixed(1)
    },
    getNumericHours (hours) {
      const value = parseFloat(hours)
      return isNaN(value) ? 0 : value
    },
    formatHours (hours) {
      return this.getNumericHours(hours).toFixed(1)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.request-subjects__user {
  max-width: 300px;
  min-width: 300px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.request-subjects__assigned-group th {
  background: #eef2f7;
  text-align: left;
  padding-top: 8px !important;
  padding-bottom: 4px !important;
}

.request-subjects__assigned-group-title {
  margin: 0;
  font-size: 12px;
  text-transform: uppercase;
  color: #8898aa;
  font-weight: bold;
}

.request-subjects__toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  background: transparent;
  color: inherit;
  font-weight: inherit;
  cursor: pointer;
  text-transform: inherit;
  text-align: left;
}

.request-subjects__assigned {
  margin-bottom: 0;
}

.request-subjects__total {
  margin-bottom: 0;
}

.request-subjects__total tbody tr:last-child td {
  border-top: 1px solid #e2e8f0;
  padding-top: 6px;
}

.pool-summary td {
  border-top: 1px solid #e2e8f0;
  padding: 8px 4px !important;
  text-align: center;
}

.pool-label {
  display: block;
  font-size: 10px;
  text-transform: uppercase;
  color: #8898aa;
  font-weight: bold;
  margin-bottom: 2px;
}

.pool-value {
  display: block;
  font-size: 14px;
  font-weight: bold;
  color: #3e4450;
}

.pool-value--negative {
  color: #e74c3c;
}

.pool-headline-container {
  text-align: right !important;
}

.request-subjects__toggle__left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.request-subjects__toggle__left h4 {
  color: #3e4450;
}

.request-subjects__toggle__sum {
  color: #000;
}

.number {
  text-align: right !important;
}

.color--grey {
  color: #8898aa !important;
}

.td-type {
  font-size: 10px;
  color: #8898aa;
}


.subjects_subject {
  position: relative;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff;
  border-radius: 4px;
  word-break: break-all;
  background: transparent;
  overflow: hidden;
  text-align: left;
  margin: 2.5px 5px 2.5px 0px;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  border-left: 2px solid transparent;
  animation: fadeIn;
  cursor: pointer;
  width: 135px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
}

.subjects_subject.subjects_subject--has-user {
  padding-right: 20px;
}

.subjects_subject.subjects_subject--has-user:after {
  content: "\eaf7";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #b7b7b7;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.subjects_subject.subjects_subject__simple {
  border: 1px solid var(--border-color);
  border-left: 2px solid transparent;
  background: #ffffff !important;
  color: var(--dark-blue);
  box-shadow: none;
}

.d-table, .subjects-and-tasks {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
  border-width: 1px 0;
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  border-width: 1px 0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.request-subjects__user .d-table > thead {
  height: 33px;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th, .d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table td,
.d-table th {
  padding: 0 4px;
}

.td-subjects {
  width: 135px;
}

.d-table td.td-subjects.td-subjects--assigned {
  padding-left: 5px;
}

.td-calendars {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 65px;
  overflow: hidden;
  font-size: 11px;
}

.d-table td.td-subjects {
  position: relative;
  padding: 0 4px 0 0;
}

.number-and-delete .do-bttn {
  display: none;
}

tr:hover > .number-and-delete > span {
  display: none;
}
tr:hover > .number-and-delete > .do-bttn {
  display: inline-block;
}

.td-delete {
  width: 20px;
  padding: 0 !important;
}

.td-delete .do-spinner {
  margin: 0 6px;
}

</style>



// WEBPACK FOOTER //
// RequestSubjectsUser.vue?89ed0cca